import React, { useCallback, useState } from 'react';
import { Box, Button } from '@mui/material';
import { teesPropertiesObject } from '../../tools/generalProperties';
import CustomIcon from '../CustomIcon';
import IdealMeasureSlider from '../IdealMeasureSlider';
import { TeeMeasureLabel } from '../../types/databaseTables/idealteemeasures';

function HelpContentsIdealMeasurements() {
  const [sliderValue, setSliderValue] = useState(40);

  function updateFromSliderFunction(labelToUpdate: TeeMeasureLabel, newMeasure: number) {
    setSliderValue(newMeasure);
  }

  const updateFromSlider = useCallback(updateFromSliderFunction, [sliderValue]);

  return (
    <Box sx={{ margin: '24px 24px' }}>
      <p>This is where you can adjust your ideal t-shirt measurements.</p>
      <p>
        An important thing to note is that{' '}
        <b>the measurements represent the direct measurement across the t-shirt</b>, (and <b>not</b>{' '}
        of your own body).
      </p>
      <p>
        For example, this <b>chest</b> measurement is taken by taking a measurement between a point
        just below the arm-pits of a t-shirt laid flat:
      </p>
      <Box sx={{ textAlign: 'center' }}>
        <CustomIcon imageRef={teesPropertiesObject.chest.imageRef} />
      </Box>
      <p>
        Move the slider thumb to adjust your ideal measure preference. Or use the <b>+</b> and{' '}
        <b>-</b> buttons to fine-tune the measurement:
      </p>

      <IdealMeasureSlider
        eachMeasureProperties={{
          name: 'chest',
          min: 20,
          max: 90,
          imageRef: teesPropertiesObject.chest.imageRef,
        }}
        measureLabel='chest'
        parentValue={sliderValue}
        updateParentState={updateFromSlider}
      />
      <p>
        So now, if you find that the next t-shirt you buy is slightly to big/small, you can come here and update your preferences to ensure you find the right size of garment.
      </p>
      <p>
        Don&apos;t forget to click the <b>Save Changes</b> button once you&apos;ve finished!
      </p>
      <br />
      <Box sx={{ textAlign: 'center' }}>
        <Button variant='contained' color='primary' size='large'>
          Back to Ideal Measurements Page
        </Button>{' '}
      </Box>
    </Box>
  );
}

export default HelpContentsIdealMeasurements;
